import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row } from 'react-bootstrap';
import cn from 'classnames';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import Details from '../event_components/details';
import AttendButton from '../event_components/attend_button';
import styles from './tile.scss';
import PaddedComponent from './top_padder';
import GoogleLocation from '../event_components/google_location';
import ConferenceData from '../event_components/conference_data';
import EventStatus from '../event_components/event_status';
import AddEventToCalendar from '../event_components/add_to_calendar';
import Host from '../event_components/host';
import CheckoutController from '../event_components/Checkout';
import { attendButtonIsVisible } from './utils';

PaddedComponent.propTypes = {
  children: PropTypes.node,
};

class Tile extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }
  toggleAttendButton = () => {
    const { event, onResizeComponent } = this.props;

    if (event.get('type') === 'google') {
      return;
    }
    this.setState(
      {
        openTicketing: !this.state.openTicketing,
      },
      () => onResizeComponent && onResizeComponent()
    );
  };
  render() {
    const { event, settings, noTitle = false, className = '', onResizeComponent } = this.props;

    const hasLogo = settings.get('showEventLogo');
    const imageSize = settings.get('imageSize');

    return (
      <CheckoutController
        variant="default"
        event={event}
        settings={settings}
        openTicketing={this.state.openTicketing}
        onResizeComponent={onResizeComponent}
        transitionClassName="checkout-transition"
        onClose={() => {
          this.setState({
            openTicketing: false,
          });
        }}
      >
        <Row className={cn('event', styles.tile, styles.event, className)} key={event.get('id')}>
          {hasLogo && event.get('type') !== 'zoom' && (
            <div className={styles.header}>
              <Logo event={event} className={cn(styles.photo)} imgClassName={styles[imageSize || 'small']} settings={settings} />
            </div>
          )}
          {!noTitle && <Title event={event} className={styles.title} settings={settings} />}
          <div className={styles.container}>
            <PaddedComponent>
              <Time
                withIcon
                event={event}
                settings={settings}
                className={styles.time}
                // format="ddd D MMM YYYY HH:mm"
              />
              {settings.get('enableAddToCalendar') && <AddEventToCalendar event={event} settings={settings} />}
            </PaddedComponent>
            {(settings.get('showVenue') || settings.get('showFullAddress')) && (
              <PaddedComponent>
                {event.get('type') === 'google' ? (
                  <GoogleLocation event={event} />
                ) : (
                  <Location settings={settings} event={event} showFullAddress={settings.get('showFullAddress')} withIcon />
                )}
              </PaddedComponent>
            )}
            {event.has('conferenceData') && (
              <PaddedComponent>
                <ConferenceData event={event} />{' '}
              </PaddedComponent>
            )}
            {settings.get('showEventStatus') && (
              <PaddedComponent>
                <EventStatus event={event} settings={settings} className={styles.eventStatus} />
              </PaddedComponent>
            )}
            <PaddedComponent>
              <Details event={event} settings={settings} className={styles.details} onResizeComponent={onResizeComponent} />
            </PaddedComponent>

            {event.get('type') === 'zoom' && <Host event={event} settings={settings} className={styles.zoomHost} />}

            {attendButtonIsVisible(event, settings) && (
              <AttendButton event={event} settings={settings} className={styles.buttonRow} handleButtonClick={this.toggleAttendButton} />
            )}
          </div>
        </Row>
      </CheckoutController>
    );
  }
}
Tile.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export default Tile;
